<script>
  import { _ } from 'svelte-i18n';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  // The value bound to this component
  export let selected_value = '';
  export let options = [];
  
  // Handle selection
  function select(option) {
    selected_value = option;
    dispatch('change', { selected_value });
  }
  
</script>

<div class="button-switch">
  {#each options as option}
    <button 
      type="button"
      class="button-switch-btn {option.size === 'small' ? 'small' : ''} {selected_value === option.value ? 'contrast' : 'secondary outline'}"
      on:click={() => select(option.value)}
    >
    {#if selected_value === option.value}
      <ion-icon name="checkmark-outline"></ion-icon>
    {/if}
      {option.label}
    </button>
  {/each}
</div>
